import React from 'react';

import { colors, container, line } from '../theme';
import { pressLogos } from '../data';

// Small helper so the fade-on-hover works without a stylesheet rule.
function PressLogo({ logo }) {
  return (
    <img
      src={logo.img}
      alt={logo.alt}
      style={{ height: logo.height, width: 'auto', opacity: 0.66, transition: 'opacity .3s' }}
      onMouseOver={(e) => {
        e.currentTarget.style.opacity = 1;
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.opacity = 0.66;
      }}
    />
  );
}

export default function Press() {
  return (
    <section id="press" style={{ borderTop: line.faint, background: colors.bgAlt }}>
      <div className="lyfe-wrap lyfe-sec" style={{ ...container, padding: '104px 40px 110px' }}>
        <div className="lyfe-reveal" style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto 48px' }}>
          <div
            style={{
              fontSize: 13,
              letterSpacing: '.26em',
              textTransform: 'uppercase',
              color: colors.muted2,
              fontWeight: 600,
            }}>
            As seen in
          </div>
        </div>
        <div
          className="lyfe-reveal"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '56px 80px',
          }}>
          {pressLogos.map((logo) => (
            <PressLogo key={logo.alt} logo={logo} />
          ))}
        </div>
      </div>
    </section>
  );
}
